import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Tooltip, Typography } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import PVForms from "../../Custom/PVForms";
import { useDispatch, useSelector } from "react-redux";
import { addBot, analyticsInstanceSelector, checkAndJoinGame, connectedSelector, createGame, createGameWithBots, discardCard, gameSelector, joinGame, makeMove, presenceSelector, requestRematch, sendFeedback, setCurrentUser, setPlayers, startGame, subscribeToGame, trackGame, unsubscribeFromGame } from "../../services/GameSlice";
import { getSocket } from "../../socket";
import { nanoid } from "@reduxjs/toolkit";
import PVTable from "../../Custom/PVTable";
import copy from "copy-to-clipboard";
import { setBody, setToastId, setType } from "../../services/NotificationSlice";
import ColorPicker from "react-pick-color";
import { addFromConnector, addToConnector, createCall, destroyConnection, peerConnectionsSelector } from "../../services/PeerConnectionsSlice";
import * as Peer from 'simple-peer';
import { setUserId as analyticsUserId, logEvent } from "firebase/analytics";
import { Link } from "react-router-dom";

// One id for the removal toast means a second removal replaces the first
// rather than stacking another box on top of it.
const REMOVAL_TOAST = 'chip-removed';

const Board = () => {

    const params = useParams();
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 600);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 600);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const [record, setRecord] = useState({});
    const [nameRecord, setNameRecord] = useState({});
    const [userId, setUserId] = useState('');
    const [selectedCard, setSelectedCard] = useState(null);
    const [removal, setRemoval] = useState(null);
    const previousBoard = useRef(null);
    const [feedbackForm, setFeedbackForm] = useState({});
    const [color, setColor] = useState('#03b1fc');
    const [opneColorPicker, setOpenColorPicker] = useState(false);
    const [mediaStream, setMediaStream] = useState(null);
    const [connections, setConnections] = useState([]);
    const analytics = useSelector(analyticsInstanceSelector);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const game = useSelector(gameSelector);
    const peerConnections = useSelector(peerConnectionsSelector);
    const presence = useSelector(presenceSelector);
    const connected = useSelector(connectedSelector);

    const data = {
        '0,0': 'blank_card',
        '0,1': 'spades_10',
        '0,2': 'spades_queen',
        '0,3': 'spades_king',
        '0,4': 'spades_ace_simple',
        '0,5': 'diamonds_2',
        '0,6': 'diamonds_3',
        '0,7': 'diamonds_4',
        '0,8': 'diamonds_5',
        '0,9': 'blank_card',

        '1,0': 'spades_9',
        '1,1': 'hearts_10',
        '1,2': 'hearts_9',
        '1,3': 'hearts_8',
        '1,4': 'hearts_7',
        '1,5': 'hearts_6',
        '1,6': 'hearts_5',
        '1,7': 'hearts_4',
        '1,8': 'hearts_3',
        '1,9': 'diamonds_6',

        '2,0': 'spades_8',
        '2,1': 'hearts_queen',
        '2,2': 'diamonds_7',
        '2,3': 'diamonds_8',
        '2,4': 'diamonds_9',
        '2,5': 'diamonds_10',
        '2,6': 'diamonds_queen',
        '2,7': 'diamonds_king',
        '2,8': 'hearts_2',
        '2,9': 'diamonds_7',

        '3,0': 'spades_7',
        '3,1': 'hearts_king',
        '3,2': 'diamonds_6',
        '3,3': 'clubs_2',
        '3,4': 'hearts_ace',
        '3,5': 'hearts_king',
        '3,6': 'hearts_queen',
        '3,7': 'diamonds_ace',
        '3,8': 'spades_2',
        '3,9': 'diamonds_8',

        '4,0': 'spades_6',
        '4,1': 'hearts_ace',
        '4,2': 'diamonds_5',
        '4,3': 'clubs_3',
        '4,4': 'hearts_4',
        '4,5': 'hearts_3',
        '4,6': 'hearts_10',
        '4,7': 'clubs_ace',
        '4,8': 'spades_3',
        '4,9': 'diamonds_9',

        '5,0': 'spades_5', 
        '5,1': 'clubs_2',
        '5,2': 'diamonds_4',
        '5,3': 'clubs_4',
        '5,4': 'hearts_5',
        '5,5': 'hearts_2',
        '5,6': 'hearts_9',
        '5,7': 'clubs_king',
        '5,8': 'spades_4',
        '5,9': 'diamonds_10',

        '6,0': 'spades_4',
        '6,1': 'clubs_3',
        '6,2': 'diamonds_3',
        '6,3': 'clubs_5',
        '6,4': 'hearts_6',
        '6,5': 'hearts_7',
        '6,6': 'hearts_8',
        '6,7': 'clubs_queen',
        '6,8': 'spades_5',
        '6,9': 'diamonds_queen',

        '7,0': 'spades_3',
        '7,1': 'clubs_4',
        '7,2': 'diamonds_2',
        '7,3': 'clubs_6',
        '7,4': 'clubs_7',
        '7,5': 'clubs_8',
        '7,6': 'clubs_9',
        '7,7': 'clubs_10',
        '7,8': 'spades_6',
        '7,9': 'diamonds_king',

        '8,0': 'spades_2',
        '8,1': 'clubs_5',
        '8,2': 'spades_ace_simple',
        '8,3': 'spades_king',
        '8,4': 'spades_queen',
        '8,5': 'spades_10',
        '8,6': 'spades_9',
        '8,7': 'spades_8',
        '8,8': 'spades_7',
        '8,9': 'diamonds_ace',

        '9,0': 'blank_card',
        '9,1': 'clubs_6',
        '9,2': 'clubs_7',
        '9,3': 'clubs_8',
        '9,4': 'clubs_9',
        '9,5': 'clubs_10',
        '9,6': 'clubs_queen',
        '9,7': 'clubs_king',
        '9,8': 'clubs_ace',
        '9,9': 'blank_card'
    }

    useEffect(() => {
        if(Boolean(analytics) && Boolean(userId)){
            analyticsUserId(analytics, userId);
            logEvent(analytics, 'game_intialized', { userId })
        }
    }, [analytics, userId])

    // Establish the player identity once. Everything else keys off `userId`.
    useEffect(() => {
        let storedUserId = localStorage.getItem("userId");
        if(!Boolean(storedUserId)){
            storedUserId = nanoid();
            localStorage.setItem("userId", storedUserId);
        }
        setUserId(storedUserId);
        dispatch(setCurrentUser(storedUserId));
    }, [dispatch])

    // Subscribe to the game's room. The server pushes every later change, and
    // re-subscribes automatically after a reconnect, so there is no polling.
    useEffect(() => {
        if(!Boolean(userId)){
            return;
        }
        if(!Boolean(params.gameId)){
            setRecord({open: true, editRecord: {tabValue: 0}});
            return;
        }

        const socket = getSocket();
        const subscribe = () => dispatch(subscribeToGame(params.gameId, userId));

        subscribe();
        socket.on('connect', subscribe);

        return () => {
            socket.off('connect', subscribe);
            dispatch(unsubscribeFromGame());
        };
    }, [params.gameId, userId, dispatch])

    // When the rematch begins, every player still watching the finished game is
    // carried across to it. Anyone opening the old link later follows the same
    // hop, so a shared URL never dead-ends on a finished board.
    useEffect(() => {
        const rematchId = game?.rematch?.gameId ? String(game.rematch.gameId) : null;
        if(game?.rematch?.started && rematchId && rematchId !== params.gameId){
            navigate(`/${rematchId}`);
        }
    }, [game, params.gameId, navigate])

    // A card picked up in the previous game must not carry into the next one.
    useEffect(() => {
        setSelectedCard(null);
    }, [params.gameId])

    // Ask for a name as soon as we know this player is not in the game yet.
    useEffect(() => {
        if(!Boolean(userId) || !Boolean(params.gameId) || !Boolean(game?.players)){
            return;
        }
        const alreadyJoined = game.players.some(item => item.userId === userId);
        const joinable = game.status === 'INIT' || game.status === 'WAITING';
        if(!alreadyJoined && joinable){
            setNameRecord(current => current?.open === true ? current : {open: true, editRecord: {userId: userId}});
        }
    }, [game, userId, params.gameId])


    useEffect(() => {
        if(Array.isArray(peerConnections) && peerConnections.length > 0){
            const initiator = peerConnections?.filter(item => item.fromUserId === userId);
            const receiver = peerConnections?.filter(item => item.toUserId === userId);
            let dataConnections = [];
            initiator?.forEach(item => {
                if(!connections.find(i => i.id === item._id)){
                    var peer = new Peer({
                        initiator: true,
                        trickle: false,
                        stream: mediaStream,
                        offerOptions: {
                            offerToReceiveAudio: true,
                            offerToReceiveVideo: true
                        },
                        channelName: game.gameId,
                    })
                    peer.on('signal', (data) => {
                        dispatch(addFromConnector(item._id, data));
                    })
                    peer.on('stream', (stream) => {
                        var video = document.getElementById(item.toUserId);
                        if('srcObject' in video){
                            video.srcObject = stream;
                        } else {
                            video.src = window.URL.createObjectURL(stream);
                        }
                        video.play();
                    });
                    peer.on('error', (err) => {
                        dispatch(destroyConnection(item._id));
                        peer.destroy();
                    })
                    dataConnections.push({
                        id: item._id,
                        type: 'initiator',
                        peer: peer,
                        waitingToDet: true
                    });
                } else {
                    dataConnections.push(connections.find(i => i.id === item._id));
                }
            })
            receiver?.forEach(item => {
                if(!connections.find(i => i.id === item._id)){
                    var peer = new Peer({
                        initiator: false,
                        trickle: false,
                        stream: mediaStream,
                        offerOptions: {
                            offerToReceiveAudio: true,
                            offerToReceiveVideo: true
                        },
                        channelName: game.gameId,
                    });
                    peer.on('signal', (data) => {
                        dispatch(addToConnector(item._id, data));
                    })
                    peer.on('stream', (stream) => {
                        var video = document.getElementById(item.fromUserId);
                        if('srcObject' in video){
                            video.srcObject = stream;
                        } else {
                            video.src = window.URL.createObjectURL(stream);
                        }
                        video.play();
                    });
                    peer.on('error', (err) => {
                        dispatch(destroyConnection(item._id));
                        peer.destroy();
                    })
                    dataConnections.push({
                        id: item._id,
                        type: 'receiver',
                        peer: peer,
                        waitingFromDet: true
                    });
                } else {
                    dataConnections.push(connections.find(i => i.id === item._id));
                }
            })
            dataConnections.forEach(item => {
                if(item.type === 'initiator' && item.waitingToDet && peerConnections.find(i => i._id === item.id)?.toConnectionDet){
                    item.peer.signal(peerConnections.find(i => i._id === item.id)?.toConnectionDet);
                    item.waitingToDet = false;
                } else if(item.type === 'receiver' && item.waitingFromDet && peerConnections.find(i => i._id === item.id)?.fromConnectionDet){
                    item.peer.signal(peerConnections.find(i => i._id === item.id)?.fromConnectionDet);
                    item.waitingFromDet = false;
                }
            });
            setConnections(dataConnections);
            console.log(dataConnections);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [peerConnections, dispatch, userId, game])

    const create = () => {
        dispatch(createGame(record.editRecord, (game) => {
            setRecord({});
            navigate(`/${game._id}`)
            logEvent(analytics, 'game_created', {
                userId, gameId: game._id
            })
        }));
    }

    const playVsComputer = () => {
        dispatch(createGameWithBots({
            name: record.editRecord.name,
            userId: userId,
            difficulty: record.editRecord.difficulty || 'medium',
            bots: 1
        }, (created) => {
            setRecord({});
            navigate(`/${created._id}`);
            logEvent(analytics, 'game_vs_computer_started', {
                userId, gameId: created._id, difficulty: record.editRecord.difficulty || 'medium'
            });
        }));
    }

    const checkAndJoin = () => {
        dispatch(checkAndJoinGame({name: record.editRecord.name, userId: userId}, (game) => {
            setRecord({});
            navigate(`/${game._id}`);
        }))
        dispatch(trackGame(params.gameId, userId));
    }

    const join = () => {
        dispatch(joinGame(params.gameId, nameRecord.editRecord, () => setNameRecord({})));
        dispatch(trackGame(params.gameId, userId));
        logEvent(analytics, 'game_joined', {
            userId, gameId: params.gameId
        })
    }

    const start = () => {
        dispatch(startGame(params.gameId));
        logEvent(analytics, 'game_started', {
            userId, gameId: params.gameId
        })
    }

    const canStartGame = () => {
        if(game?.players?.length === game?.noOfPlayers
            && game?.players?.filter(item => item.team === undefined).length === 0){
            let count = {};
            game.players.forEach(item => {
                if(count[item.team]){
                    count[item.team] += 1;
                } else {
                    count[item.team] = 1;
                }
            })
            let values = Object.values(count);
            // Everyone on one colour passes the "even teams" check but is not a
            // game: every chip would belong to the same team.
            if(Object.keys(count).length >= 2 && values.every(val => val === values[0])){
                return true;
            }     
        }
        return false;
    }

    // A one-eyed jack deletes the chip from moves, so no field on the new game
    // says a removal happened — the only evidence is that a cell which was
    // occupied a moment ago is empty now. Comparing consecutive states is the
    // only way to catch it, and the player who did it is whoever was on turn in
    // the state we are comparing against.
    useEffect(() => {
        if(!game?._id){
            return;
        }
        const moves = game.moves || [];
        const now = {
            gameId: game._id,
            chips: new Map(moves.map(m => [m.pos, m])),
            onTurn: game.currentPlayer
        };
        const before = previousBoard.current;
        previousBoard.current = now;

        // Nothing to diff against on the first state, or after changing games.
        // A reload therefore misses a removal that happened while away, which
        // is the accepted cost of keeping this out of the server.
        if(!before || before.gameId !== game._id){
            return;
        }

        const takenOff = [...before.chips.keys()].filter(pos => !now.chips.has(pos));
        if(takenOff.length > 0){
            const pos = takenOff[0];
            const chip = before.chips.get(pos);
            const owner = chip.userId === userId ? 'your' : `${playerLabel(chip.userId)}'s`;
            setRemoval({ pos, team: chip.team });
            dispatch(setToastId(REMOVAL_TOAST));
            dispatch(setType('sticky'));
            dispatch(setBody(`${playerLabel(before.onTurn)} used a one-eyed jack to take ${owner} chip off the ${cardLabel(data[pos])}.`));
            return;
        }

        // Once the player has taken their own turn they have plainly seen the
        // board, so the marker and its toast have done their job.
        const iHaveMoved = moves.some(m => m.userId === userId && !before.chips.has(m.pos));
        if(removal && iHaveMoved){
            setRemoval(null);
            dispatch(setToastId(REMOVAL_TOAST));
            dispatch(setType('dismiss'));
            dispatch(setBody(' '));
        }
        // data is the fixed board layout and playerLabel only reads game, so
        // neither adds anything to react to — a new game state does.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [game, userId, removal, dispatch]);

    const move = (pos) => {
        if(((!Boolean(game?.moves?.find(m => m.pos === pos)) && selectedCard === data[pos]) ||
            (['spades_jack', 'hearts_jack'].includes(selectedCard) && game?.moves?.find(m => m.pos === pos && m.team !== game?.players?.find(p => p.userId === userId)?.team?.toLowerCase())) ||
            (['clubs_jack', 'diamonds_jack'].includes(selectedCard) && !Boolean(game?.moves?.find(m => m.pos === pos)))) && game.currentPlayer === userId &&
            ![`0,0`, `0,9`, `9,0`, `9,9`].includes(pos)){
                dispatch(makeMove(params.gameId, pos, userId, selectedCard, game));
        }
    }

    const onRowClick = (data, key) => {
        let players;
        switch (key){
            case 'assignGreen':
                players = game.players.map(item => {
                    if(item.userId === data.userId){
                        return {...item, team: 'Green'}
                    }
                    return item;
                })
                dispatch(setPlayers(game._id, players));
                break;
            case 'assignBlue': 
                players = game.players.map(item => {
                    if(item.userId === data.userId){
                        return {...item, team: 'Blue'}
                    }
                    return item;
                })
                dispatch(setPlayers(game._id, players));
                break;
            case 'assignRed':
                players = game.players.map(item => {
                    if(item.userId === data.userId){
                        return {...item, team: 'Red'}
                    }
                    return item;
                })
                dispatch(setPlayers(game._id, players));
                break;
            default:
                console.log("Nothing to execute");
        }
    }

    const cursor = (pos) => {
        if(((!Boolean(game?.moves?.find(m => m.pos === pos)) && selectedCard === data[pos]) ||
            (['spades_jack', 'hearts_jack'].includes(selectedCard) && game?.moves?.find(m => m.pos === pos && m.team !== game?.players?.find(p => p.userId === userId)?.team?.toLowerCase())) ||
            (['clubs_jack', 'diamonds_jack'].includes(selectedCard) && !Boolean(game?.moves?.find(m => m.pos === pos)))) && game.currentPlayer === userId &&
            ![`0,0`, `0,9`, `9,0`, `9,9`].includes(pos)){
            return 'pointer';
        }
        return 'not-allowed';
    }

    const isBot = (playerId) => Boolean(game?.players?.find(p => p.userId === playerId)?.isBot);

    // Computer players never have to be asked, so only the people count.
    const rematchState = () => {
        const rematch = game?.rematch;
        const humans = (game?.players || []).filter(p => !p.isBot);
        const ready = humans.filter(p => (rematch?.readyUserIds || []).includes(p.userId)).length;
        return {
            open: Boolean(rematch?.gameId) && rematch?.started !== true,
            isHost: rematch?.hostUserId === userId,
            iAmReady: (rematch?.readyUserIds || []).includes(userId),
            ready,
            total: humans.length
        };
    };

    const rematchLabel = () => {
        const state = rematchState();
        if(!state.open){
            return 'Rematch';
        }
        const tally = state.total > 1 ? ` (${state.ready}/${state.total})` : '';
        if(!state.iAmReady){
            return `Join Rematch${tally}`;
        }
        // Kept short: a longer label wraps the top bar onto two lines.
        return state.isHost ? `Start Rematch${tally}` : `Ready${tally}`;
    };

    // 'hearts_10' -> '10 of Hearts', which is how a player would say it.
    const cardLabel = (card) => {
        if(!card || card === 'blank_card'){
            return 'a free corner';
        }
        const [suit, ...rest] = String(card).split('_');
        const value = rest.join(' ').replace('ace simple', 'ace');
        const title = (word) => `${word.charAt(0).toUpperCase()}${word.slice(1)}`;
        return `${title(value)} of ${title(suit)}`;
    };

    // After a one-eyed jack the newest entry in moves is an older chip rather
    // than the latest event, so the ring is held back while the removal marker
    // is the thing worth looking at.
    const lastMovePos = () => {
        const moves = game?.moves || [];
        if(removal || moves.length === 0){
            return null;
        }
        return moves[moves.length - 1].pos;
    };

    const playerLabel = (playerId) => {
        const player = game?.players?.find(p => p.userId === playerId);
        if(!player){
            return '';
        }
        return player.isBot ? `${player.name} (Computer)` : player.name;
    };

    // A card is dead once both of its board cells are taken. The official rule
    // lets you turn it in for a new one, which also stops a hand of dead cards
    // from freezing the game.
    const deadCards = () => {
        const myCards = game?.players?.find(p => p.userId === userId)?.inHandCards || [];
        const taken = new Set((game?.moves || []).map(m => m.pos));
        return myCards.filter(card => {
            if(String(card).includes('jack')){
                return false;
            }
            const cells = Object.keys(data).filter(pos => data[pos] === card);
            return cells.length > 0 && cells.every(pos => taken.has(pos));
        });
    };

    const getWon = () => {
        if(game?.isDraw){
            return 'Game Drawn - no moves left';
        }

        const noOfTeams = game?.noOfTeams;
        if(noOfTeams === 2){
            if(game.completedSequences.red === 2){
                let players = game.players.filter(i => i.team === 'Red').map(item => item.name);
                return `Red Team(${players.join(', ')}) Won`;
            } else if(game.completedSequences.blue === 2){
                let players = game.players.filter(i => i.team === 'Blue').map(item => item.name);
                return `Blue Team(${players.join(', ')}) Won`;
            } else if(game.completedSequences.green === 2){
                let players = game.players.filter(i => i.team === 'Green').map(item => item.name);
                return `Green Team(${players.join(', ')}) Won`;
            }
        } else if(noOfTeams === 3){
            if(game.completedSequences.red === 1){
                let players = game.players.filter(i => i.team === 'Red').map(item => item.name);
                return `Red Team(${players.join(', ')}) Won`;
            } else if(game.completedSequences.blue === 1){
                let players = game.players.filter(i => i.team === 'Blue').map(item => item.name);
                return `Blue Team(${players.join(', ')}) Won`;
            } else if(game.completedSequences.green === 1){
                let players = game.players.filter(i => i.team === 'Green').map(item => item.name);
                return `Green Team(${players.join(', ')}) Won`;
            }
        }
    }

    const getMediaPermission = () => {
        navigator.mediaDevices.getUserMedia({video: true, audio: true}).then((stream) => {
            setMediaStream(stream);
            checkAndCreateConnections();
        }).catch((err) => {
            console.log(err);
        })
    }

    const checkAndCreateConnections = () => {
        if(Boolean(userId)){
            // Signalling rows are created once; later updates are pushed over
            // the socket, so there is nothing to poll for.
            dispatch(createCall(game._id));
        }
    }

    // The "last seen" label counts up in seconds. Polling used to re-render the
    // board every second as a side effect; this is a local timer that does the
    // same without touching the network, and only while someone is away.
    const [, setClockTick] = useState(0);
    const someoneOffline = Boolean(game?.players?.some(player => !presence?.online?.includes(player.userId)));
    useEffect(() => {
        if(!someoneOffline){
            return;
        }
        const timer = setInterval(() => setClockTick(tick => tick + 1), 1000);
        return () => clearInterval(timer);
    }, [someoneOffline])

    // Presence comes from the socket room, so an absent player is known
    // immediately rather than inferred from a stale poll timestamp.
    const showTime = (playerId) => {
        if(!Boolean(playerId) || presence?.online?.includes(playerId)){
            return '';
        }
        const lastSeen = presence?.lastSeen?.[playerId] || game?.lastUpdated?.[playerId];
        if(!Boolean(lastSeen)){
            return '(offline)';
        }
        return `(Last seen ${Math.round((new Date().getTime() - new Date(lastSeen).getTime()) / 1000)} seconds ago)`;
    }


    if (isMobile) {
        return (
            <Grid container style={{ minHeight: '100vh', backgroundColor: '#282c34', flexDirection: 'column' }}>
                {/* Header */}
                <Grid item style={{ padding: '20px', textAlign: 'center', borderBottom: '1px solid rgba(255,255,255,0.1)' }}>
                    <Typography variant='h4' style={{ color: '#fff', fontWeight: 700 }}>
                        Play Sequence
                    </Typography>
                    <Typography variant='body2' style={{ color: 'rgba(255,255,255,0.7)', marginTop: 4 }}>
                        The Classic Board Game Online
                    </Typography>
                </Grid>

                {/* Desktop notice */}
                <Grid item style={{ padding: '20px', textAlign: 'center' }}>
                    <Grid style={{ backgroundColor: '#3f51b5', borderRadius: '10px', padding: '16px' }}>
                        <Typography variant='h6' style={{ color: '#fff', fontWeight: 600, marginBottom: 8 }}>
                            Desktop Required for Gameplay
                        </Typography>
                        <Typography variant='body2' style={{ color: 'rgba(255,255,255,0.9)' }}>
                            The Sequence game board requires a wider screen to display all 100 board spaces and your card hand. Please open this site on a desktop or laptop computer, or rotate your tablet to landscape mode.
                        </Typography>
                    </Grid>
                </Grid>

                {/* About the game */}
                <Grid item style={{ padding: '0 20px 20px' }}>
                    <Typography variant='h6' style={{ color: '#fff', fontWeight: 600, marginBottom: 8 }}>
                        About Sequence
                    </Typography>
                    <Typography variant='body2' style={{ color: 'rgba(255,255,255,0.8)', lineHeight: 1.7, marginBottom: 12 }}>
                        Sequence is an exciting strategy board game that combines card playing with board game mechanics. Players take turns playing cards from their hand and placing chips on corresponding spaces on a 10 by 10 game board. The goal is to form rows of five connected chips before your opponents do.
                    </Typography>
                    <Typography variant='body2' style={{ color: 'rgba(255,255,255,0.8)', lineHeight: 1.7, marginBottom: 12 }}>
                        Play Sequence brings this classic board game experience to your browser for free. Create a game room, invite friends with a simple link, and enjoy real-time multiplayer gameplay with built-in chat and optional video calling. No accounts or downloads required.
                    </Typography>
                    <Typography variant='body2' style={{ color: 'rgba(255,255,255,0.8)', lineHeight: 1.7 }}>
                        The game supports 2 to 12 players across 2 or 3 teams, with special Jack cards that act as wild cards or allow you to remove opponent chips. Master the strategy of corner sequences, card counting, and defensive blocking to become a Sequence champion.
                    </Typography>
                </Grid>

                {/* Navigation links */}
                <Grid item style={{ padding: '0 20px 20px' }}>
                    <Typography variant='h6' style={{ color: '#fff', fontWeight: 600, marginBottom: 12 }}>
                        Explore
                    </Typography>
                    {[
                        { label: 'How to Play', path: '/how-to-play', desc: 'Complete rules and game guide' },
                        { label: 'Strategy Guide', path: '/strategy', desc: 'Tips and tactics to win' },
                        { label: 'FAQ', path: '/faq', desc: 'Answers to common questions' },
                        { label: 'About Us', path: '/about', desc: 'Our mission and platform features' },
                        { label: 'Contact', path: '/contact', desc: 'Get in touch with our team' },
                    ].map((link) => (
                        <Button
                            key={link.path}
                            component={Link}
                            to={link.path}
                            fullWidth
                            style={{
                                justifyContent: 'flex-start',
                                color: '#fff',
                                textTransform: 'none',
                                padding: '10px 16px',
                                marginBottom: 4,
                                backgroundColor: 'rgba(255,255,255,0.05)',
                                borderRadius: 8,
                            }}
                        >
                            <Grid>
                                <Typography variant='body1' style={{ fontWeight: 600, textAlign: 'left' }}>{link.label}</Typography>
                                <Typography variant='caption' style={{ color: 'rgba(255,255,255,0.6)', textAlign: 'left', display: 'block' }}>{link.desc}</Typography>
                            </Grid>
                        </Button>
                    ))}
                </Grid>

                {/* Legal links */}
                <Grid item style={{ padding: '20px', borderTop: '1px solid rgba(255,255,255,0.1)', textAlign: 'center' }}>
                    <Grid style={{ display: 'flex', justifyContent: 'center', gap: 16, flexWrap: 'wrap' }}>
                        <Button component={Link} to="/privacy-policy" size="small" style={{ color: 'rgba(255,255,255,0.5)', textTransform: 'none', fontSize: '0.75rem' }}>Privacy Policy</Button>
                        <Button component={Link} to="/terms" size="small" style={{ color: 'rgba(255,255,255,0.5)', textTransform: 'none', fontSize: '0.75rem' }}>Terms of Service</Button>
                    </Grid>
                    <Typography variant='caption' style={{ color: 'rgba(255,255,255,0.3)', display: 'block', marginTop: 8 }}>
                        &copy; {new Date().getFullYear()} Play Sequence. Sequence is a registered trademark of Jax Ltd.
                    </Typography>
                </Grid>
            </Grid>
        );
    }

    return (
        <Grid style={{backgroundColor: color, width: '100vw', minHeight: '100vh'}}>
            <Grid container style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center'}}>
                <Grid item>
                    <Grid style={{display: 'flex', flexDirection: 'row', alignItems: 'center', marginLeft: 10}}>
                        {[
                            { label: 'How to Play', path: '/how-to-play' },
                            { label: 'Strategy', path: '/strategy' },
                            { label: 'FAQ', path: '/faq' },
                            { label: 'About', path: '/about' },
                            { label: 'Contact', path: '/contact' },
                        ].map((link) => (
                            <Button
                                key={link.path}
                                component={Link}
                                to={link.path}
                                size="small"
                                style={{
                                    color: 'rgba(0,0,0,0.6)',
                                    textTransform: 'none',
                                    fontSize: '0.8rem',
                                    marginRight: 4,
                                }}
                            >
                                {link.label}
                            </Button>
                        ))}
                    </Grid>
                </Grid>
                <Grid item style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                    <Typography variant="h4">{game.status === 'COMPLETED'? getWon() : game.currentPlayer === userId ? 'Your Turn' : 'Not your turn'}</Typography>
                    {!connected && <Typography variant="body2" style={{color: '#b71c1c', fontWeight: 600}}>Reconnecting...</Typography>}
                </Grid>
                <Grid item>
                    <Grid style={{display: 'flex', flexDirection: 'row'}}>
                        {game?.status === 'COMPLETED' && game?.players?.some(p => p.userId === userId) &&
                            <Button
                                variant="contained"
                                color="success"
                                style={{marginRight: 20, marginTop: 10, fontWeight: 700}}
                                disabled={rematchState().open && rematchState().iAmReady && !rematchState().isHost}
                                onClick={() => {
                                    const state = rematchState();
                                    dispatch(requestRematch(params.gameId, userId, state.isHost && state.iAmReady));
                                    logEvent(analytics, 'rematch_requested', {userId, gameId: params.gameId});
                                }}
                            >{rematchLabel()}</Button>}
                        <Button variant="contained" style={{marginRight: 20, marginTop: 10}} onClick={() => {
                            setOpenColorPicker(true);
                        }}>Change Background Color</Button>
                        {game.callEnabled === true && <Button variant="contained" style={{marginRight: 20, marginTop: 10}} onClick={() => {
                            getMediaPermission(true);
                        }}>Start Call</Button>}
                        <Button variant="contained" style={{marginRight: 20, marginTop: 10}} onClick={() => {
                            setFeedbackForm({open: true});
                        }}>Feedback</Button>
                        <Button variant="contained" style={{marginRight: 20, marginTop: 10}} onClick={() => {
                            navigate('/');
                            window.location.reload();
                        }}>New Game</Button>
                    </Grid>
                </Grid>
            </Grid>
            <Dialog open={opneColorPicker}>
                <DialogTitle>Pick a Background Color</DialogTitle>
                <DialogContent>
                    <ColorPicker color={color} onChange={(c) => setColor(c.hex) }/>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setColor('#03b1fc')}>Reset</Button>
                    <Button onClick={() => setOpenColorPicker(false)}>Save</Button>
                </DialogActions>
            </Dialog>
            <PVForms 
                fields={[
                    {
                        label: 'Report Type',
                        property: 'type',
                        required: true,
                        type: 'SELECT',
                        listValues: [
                            {
                                label: 'Bug',
                                value: 'bug'
                            },
                            {
                                label: 'Feature Request',
                                value: 'feature'
                            },
                            {
                                label: 'Other',
                                value: 'other'
                            }
                        ],
                        listLabelKey: 'label',
                        listValueKey: 'value'
                    },
                    {
                        label: 'Description',
                        property: 'description',
                        required: true,
                        type: 'TEXTAREA',
                        rows: 5
                    }
                ]}
                record={feedbackForm}
                onChangeRecord={setFeedbackForm}
                title="Provide Feedback"
                saveLabel={'Submit'}
                onSaveClicked={() => {
                    dispatch(sendFeedback(feedbackForm.editRecord, () => {
                        setFeedbackForm({});
                    }))
                }}
            />
            <Dialog open={(game?.status === 'INIT' || game?.status === 'WAITING') && game?.players?.length > 0}>
                <DialogTitle>Team</DialogTitle>
                <DialogContent>
                    {game?.status === 'INIT' && <Typography variant="body1">Copy the link below and share it with your friends to start playing</Typography>}
                    {game?.status === 'WAITING' && <Typography variant="body1">Looking for another player... if nobody joins in a few seconds, a computer player will take the seat and the game will start.</Typography>}
                    {game?.status === 'INIT' && <Tooltip title="Click to Copy">
                        <span style={{cursor: 'pointer', textDecoration: 'underline'}} onClick={() => {
                            copy(window.location.href)
                            dispatch(setBody('Copied successully'));
                            dispatch(setType('success'))
                        }}>{window.location.href}</span> 
                    </Tooltip>}
                    <PVTable 
                        columns={[
                            {
                                label: 'Name',
                                property: 'name'
                            },
                            {
                                label: 'Team',
                                property: 'team'
                            }
                        ]}
                        data={game.players}
                        clickMenu={[
                            {
                                key: 'assignGreen',
                                label: 'Assign Green',
                                enabled: (game?.noOfPlayers % 2 === 0 || game?.noOfPlayers % 3 === 0) && game?.players?.filter(item => item.team === 'Green').length < Math.floor(game?.noOfPlayers / 2)
                            },
                            {
                                key: 'assignBlue',
                                label: 'Assign Blue',
                                enabled: (game?.noOfPlayers % 2 === 0 || game?.noOfPlayers % 3 === 0) && game?.players?.filter(item => item.team === 'Blue').length < Math.floor(game?.noOfPlayers / 2)
                            },
                            {
                                key: 'assignRed',
                                label: 'Assign Red',
                                enabled: game?.noOfPlayers % 3 === 0
                            }
                        ]}
                        onRowClick={onRowClick}
                    />
                </DialogContent>
                <DialogActions style={{textAlign: 'center'}}>
                    {game?.players?.length < game?.noOfPlayers &&
                        <Button onClick={() => dispatch(addBot(params.gameId, 'medium'))}>Add Computer Player</Button>}
                    <Button onClick={start} disabled={!canStartGame()}>Start Game</Button>
                </DialogActions>
            </Dialog>

            <PVForms 
                fields={[
                    {
                        label: 'New Game',
                        property: 'tabValue',
                        listValues: [
                            {
                                label: 'Create New Game',
                                value: 0
                            },
                            {
                                label: 'Join Web Game (Beta)',
                                value: 1
                            },
                            {
                                label: 'Play vs Computer',
                                value: 2
                            }
                        ],
                        type: 'TABS'
                    },
                    {
                        type: 'CUSTOM',
                        reactComponent: <Typography variant="caption" style={{textAlign: 'center'}}>Use this to play with your friends (You will get a sharable link in the next step)</Typography>,
                        visible: record?.editRecord?.tabValue === 0
                    },
                    {
                        type: 'CUSTOM',
                        reactComponent: <Typography variant="caption" style={{textAlign: 'center'}}>Use this to join a game with a random person (Beta)</Typography>,
                        visible: record?.editRecord?.tabValue === 1
                    },
                    {
                        type: 'CUSTOM',
                        reactComponent: <Typography variant="caption" style={{textAlign: 'center'}}>Play straight away against the computer - no one else needed</Typography>,
                        visible: record?.editRecord?.tabValue === 2
                    },
                    {
                        label: 'Difficulty',
                        property: 'difficulty',
                        required: record?.editRecord?.tabValue === 2,
                        type: 'SELECT',
                        listValues: [
                            {label: 'Easy - plays at random', value: 'easy'},
                            {label: 'Medium - blocks and builds', value: 'medium'},
                            {label: 'Hard - hunts for double threats', value: 'hard'}
                        ],
                        listLabelKey: 'label',
                        listValueKey: 'value',
                        visible: record?.editRecord?.tabValue === 2
                    },
                    {
                        label: 'Room Name',
                        property: 'roomName',
                        required: record?.editRecord?.tabValue === 0,
                        visible: record?.editRecord?.tabValue === 0
                    },
                    {
                        label: 'Number of Players',
                        property: 'noOfPlayers',
                        required: record?.editRecord?.tabValue === 0,
                        dataType: 'number',
                        error: Boolean(record?.editRecord?.noOfPlayers) && !(record?.editRecord?.noOfPlayers > 1 
                            && record?.editRecord?.noOfPlayers <= 12 
                            && (record?.editRecord?.noOfPlayers % 2 === 0 || record?.editRecord?.noOfPlayers % 3 === 0)),
                        visible: record?.editRecord?.tabValue === 0
                    },
                    {
                        label: 'Name',
                        property: 'name',
                        required: record?.editRecord?.tabValue === 1 || record?.editRecord?.tabValue === 2,
                        visible: record?.editRecord?.tabValue === 1 || record?.editRecord?.tabValue === 2
                    }
                ]}
                record={record}
                onChangeRecord={setRecord}
                // title="Create a Game"
                onSaveClicked={record?.editRecord?.tabValue === 0 ? create
                    : record?.editRecord?.tabValue === 2 ? playVsComputer : checkAndJoin}
                saveLabel={record?.editRecord?.tabValue === 0 ? 'Create'
                    : record?.editRecord?.tabValue === 2 ? 'Play' : 'Join'}
            />
            <PVForms 
                fields={[
                    {
                        label: 'Name',
                        property: 'name',
                        required: true
                    }
                ]}
                record={nameRecord}
                onChangeRecord={setNameRecord}
                title="User Name"
                saveLabel={'Join Game'}
                onSaveClicked={join}
            />
            <Grid container>
                <Grid item xs={12} md={8} lg={8} style={{marginTop: '10vh', textAlign: 'center'}}>
                    <Typography variant="h3">Board</Typography>
                    {Array.from({ length: 10 }).map((lol, i) => (
                        <Grid container key={i}>
                            <Grid item xs={1} md={1} lg={1}/>
                            {Array.from({ length: 10 }).map((lol1, j) => (
                                <Grid item xs={1} md={1} lg={1} key={j} style={{ paddingLeft: 5, paddingRight: 5, textAlign: 'center', position: 'relative' }}>
                                <img
                                    src={`https://d5hzzxzqjp9y1.cloudfront.net/cardfronts/${Object.keys(data).includes(`${i},${j}`) ? data[`${i},${j}`] : 'spades_ace_simple'}.png`}
                                    alt={`At ${i} ${j}`}
                                    width={'100%'}
                                    onClick={() => move(`${i},${j}`)}
                                    style={{cursor: cursor(`${i},${j}`),
                                            border: Boolean(game?.moves?.find(m => m.pos === `${i},${j}`)?.completedSequence) ? '2px solid black' : 'none',}}
                                />
                                {game?.moves && Boolean(game.moves.find(m => m.pos === `${i},${j}`)) && <div
                                    className={lastMovePos() === `${i},${j}` ? 'last-move' : undefined}
                                    title={lastMovePos() === `${i},${j}` ? `Last move: ${playerLabel(game.moves[game.moves.length - 1].userId)} played the ${cardLabel(game.moves[game.moves.length - 1].card)}` : undefined}
                                    style={{
                                    position: 'absolute',
                                    top: '50%',
                                    left: '50%',
                                    transform: 'translate(-50%, -50%)',
                                    width: 25,
                                    height: 25,
                                    backgroundColor: game.moves.find(m => m.pos === `${i},${j}`).team,
                                    borderRadius: '50%',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    cursor: cursor(`${i},${j}`)
                                }} onClick={() => move(`${i},${j}`)}/>}
                                {removal?.pos === `${i},${j}` && <div
                                    className="removed-chip"
                                    title={`A ${removal.team} chip was taken off this cell with a one-eyed jack`}
                                    style={{
                                    position: 'absolute',
                                    top: '50%',
                                    left: '50%',
                                    transform: 'translate(-50%, -50%)',
                                    width: 25,
                                    height: 25,
                                    color: removal.team,
                                    borderRadius: '50%',
                                    cursor: cursor(`${i},${j}`)
                                }} onClick={() => move(`${i},${j}`)}/>}
                                </Grid>
                            ))}
                            <Grid item xs={1} md={1} lg={1}/>
                        </Grid>
                    ))}
                </Grid>
                <Grid item xs={12} md={4} lg={4} style={{marginTop: '10vh', paddingRight: '20px'}}>
                    <Typography variant="h3">{`Your Cards (${Boolean(game?.players?.find(p => p.userId === userId)?.team) ? game?.players?.find(p => p.userId === userId)?.team: ''})`}</Typography>
                    {isBot(game?.currentPlayer) && game?.status === 'START' &&
                        <Typography variant="body2" style={{fontStyle: 'italic', color: 'rgba(0,0,0,0.6)'}}>
                            {`${playerLabel(game?.currentPlayer)} is thinking...`}
                        </Typography>}
                    {game?.currentPlayer === userId && game?.status === 'START' && deadCards().length > 0 &&
                        <Button size="small" variant="outlined" style={{marginTop: 6}}
                            onClick={() => dispatch(discardCard(params.gameId, userId, deadCards()[0]))}>
                            {`Turn in dead card (${deadCards()[0].replace(/_/g, ' ')})`}
                        </Button>}
                    <Typography variant="body1">{`Current Player - ${playerLabel(game?.currentPlayer)} ${isBot(game?.currentPlayer) ? '' : showTime(game?.currentPlayer)}`}</Typography>
                    <Grid container style={{justifyContent: 'center', marginTop: '3vh'}}>
                        {game?.players?.filter(user => user.userId === userId)?.[0]?.inHandCards && game?.players?.filter(user => user.userId === userId)[0]?.inHandCards.map((_, i) => (
                            <Grid item xs={3} md={3} lg={3}>
                                <img
                                    src={`https://d5hzzxzqjp9y1.cloudfront.net/cardfronts/${game?.players?.filter(user => user.userId === userId)[0]?.inHandCards[i]}.png`}
                                    alt={`At ${i} ${i}`}
                                    width={'100%'}
                                    onClick={() => {
                                        if(game.currentPlayer === userId){
                                            setSelectedCard(game?.players?.filter(user => user.userId === userId)[0]?.inHandCards[i])
                                        }
                                    }}
                                    style={{cursor: game.currentPlayer === userId ? 'pointer' : 'not-allowed',
                                            transform: 'rotate(-90deg)'}}
                                />
                            </Grid>
                        ))}
                    </Grid>

                    {game.callEnabled === true && <Grid container style={{justifyContent: 'center', marginTop: '5vh'}}>
                        {game?.players?.filter(user => user.userId !== userId)?.map((user, i) => (
                            <Grid item xs={12} md={5} lg={5} style={{textAlign: 'center'}}>
                                <Typography variant="body1">{user.name}</Typography>
                                <video id={user.userId} style={{width: 150, height: 150}}/>
                            </Grid>
                        ))}
                    </Grid>}
                </Grid>
            </Grid>

            {/* SEO Content Section */}
            <Grid container style={{ backgroundColor: '#1a1d23', padding: '40px 20px', marginTop: 20 }}>
                <Grid item xs={12} style={{ maxWidth: 1000, margin: '0 auto' }}>
                    <Typography variant="h5" style={{ color: '#fff', fontWeight: 700, marginBottom: 16, textAlign: 'center' }}>
                        Play Sequence Online - Free Multiplayer Board Game
                    </Typography>
                    <Typography variant="body2" style={{ color: 'rgba(255,255,255,0.75)', lineHeight: 1.8, marginBottom: 12 }}>
                        Welcome to Play Sequence, the free online platform where you can enjoy the classic Sequence board game with friends and family from anywhere in the world. Sequence is a strategy board game that combines card playing with board game mechanics on a 10 by 10 grid. Players take turns playing cards from their hand and placing chips on matching board spaces, racing to form rows of five connected chips in a horizontal, vertical, or diagonal line.
                    </Typography>
                    <Typography variant="body2" style={{ color: 'rgba(255,255,255,0.75)', lineHeight: 1.8, marginBottom: 12 }}>
                        Our platform supports 2 to 12 players across 2 or 3 teams, making it perfect for both quick head-to-head matches and large group game nights. Create a game room, share the link with your friends, and start playing in seconds. No accounts, no downloads, and no fees. The game includes special Jack cards that serve as wild cards or allow you to remove opponent chips, adding layers of strategy to every match. Use the built-in chat to communicate with other players, or enable video calling for a more social experience.
                    </Typography>
                    <Typography variant="body2" style={{ color: 'rgba(255,255,255,0.75)', lineHeight: 1.8 }}>
                        Whether you are new to Sequence or a seasoned player, our platform provides everything you need for an authentic game experience. The game engine handles all rules automatically, including turn order, valid move checking, sequence detection, and win conditions. Visit our How to Play guide to learn the complete rules, or check out the Strategy Guide for expert tips on corner sequences, Jack card management, and defensive blocking techniques.
                    </Typography>
                </Grid>
            </Grid>

            {/* Footer with Navigation */}
            <Grid container style={{ backgroundColor: '#111318', padding: '24px 20px' }}>
                <Grid item xs={12} style={{ maxWidth: 1000, margin: '0 auto' }}>
                    <Grid container style={{ justifyContent: 'center', gap: 8, flexWrap: 'wrap', marginBottom: 12 }}>
                        {[
                            { label: 'How to Play', path: '/how-to-play' },
                            { label: 'Strategy', path: '/strategy' },
                            { label: 'FAQ', path: '/faq' },
                            { label: 'About', path: '/about' },
                            { label: 'Contact', path: '/contact' },
                            { label: 'Privacy Policy', path: '/privacy-policy' },
                            { label: 'Terms of Service', path: '/terms' },
                        ].map((link) => (
                            <Button
                                key={link.path}
                                component={Link}
                                to={link.path}
                                size="small"
                                style={{ color: 'rgba(255,255,255,0.5)', textTransform: 'none', fontSize: '0.75rem' }}
                            >
                                {link.label}
                            </Button>
                        ))}
                    </Grid>
                    <Typography variant="caption" style={{ color: 'rgba(255,255,255,0.3)', display: 'block', textAlign: 'center' }}>
                        &copy; {new Date().getFullYear()} Play Sequence. All rights reserved. Sequence is a registered trademark of Jax Ltd.
                    </Typography>
                </Grid>
            </Grid>
        </Grid>
    )
}

export default Board;